import _ from 'lodash';
import {
    ActionTypeNames, ChangeItemsPerPageAction, GoToPageAction,
    NextPageAction, PrevPageAction, RemoveFilterAction, SearchAction,
    SelectAction, SelectAllAction, SetFilterAction, StorePagingStateAction, StoreSortingStateAction, UnselectAction, UnselectAllAction, ClearSelectionAction,
} from './actions';
import { TablePaging, TableSorting } from './state';

export function select(tableKey: string, id: string): SelectAction {
    return {
        id,
        tableKey,
        type: ActionTypeNames.Select,
    };
}

export function unselect(tableKey: string, id: string): UnselectAction {
    return {
        id,
        tableKey,
        type: ActionTypeNames.Unselect,
    };
}

export function selectAll(tableKey: string, ids: string[]): SelectAllAction {
    return {
        ids,
        tableKey,
        type: ActionTypeNames.SelectAll,
    };
}

export function unselectAll(tableKey: string, ids: string[]): UnselectAllAction {
  return {
    ids,
    tableKey,
    type: ActionTypeNames.UnselectAll,
  };
}

export function clearSelection(tableKey: string): ClearSelectionAction {
  return {
    tableKey,
    type: ActionTypeNames.ClearSelection,
  };
}

export function nextPage(tableKey: string): NextPageAction {
    return {
        tableKey,
        type: ActionTypeNames.NextPage,
    };
}

export function prevPage(tableKey: string): PrevPageAction {
    return {
        tableKey,
        type: ActionTypeNames.PrevPage,
    };
}

export function goToPage(tableKey: string, pageNumber: number): GoToPageAction {
    return {
        pageNumber,
        tableKey,
        type: ActionTypeNames.GoToPage,
    };
}

export function changeItemsPerPage(tableKey: string, itemsPerPage: number): ChangeItemsPerPageAction {
    return {
        itemsPerPage,
        tableKey,
        type: ActionTypeNames.ChangeItemsPerPage
    };
}

export function storePagingState(tableKey: string, state: Partial<TablePaging>): StorePagingStateAction {
    return {
        state,
        tableKey,
        type: ActionTypeNames.StorePagingState
    };
}

export function storeSortingState(tableKey: string, state: Partial<TableSorting>): StoreSortingStateAction {
    return {
        state,
        tableKey,
        type: ActionTypeNames.StoreSortingState
    };
}

export function search(tableKey: string, str: string): SearchAction {
    return {
        str,
        tableKey,
        type: ActionTypeNames.Search,
    };
}

export function setFilter(tableKey: string, key: string, selection: string[]): SetFilterAction {
    return {
        key,
        selection,
        tableKey,
        type: ActionTypeNames.SetFilter
    };
}

export function removeFilter(tableKey: string, key: string): RemoveFilterAction {
    return {
        key,
        tableKey,
        type: ActionTypeNames.RemoveFilter,
    };
}